import { render, staticRenderFns } from "./BrochureDetailModule.vue?vue&type=template&id=6af266bf&"
import script from "./BrochureDetailModule.ts?vue&type=script&lang=ts&"
export * from "./BrochureDetailModule.ts?vue&type=script&lang=ts&"
import style0 from "./BrochureDetailModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports